import { initial as zoomConfig } from '../../../config/zoom';
import { IViewerStoreInjector, appContainer } from '../../../inversify.config';
import { TYPES } from '../../../inversify.types';

export const pinchZoomInShortcut = {
  key: new Set(['PinchZoomIn']),
  callBackFunction: () => {
    const { zoom, setZoom, setViewOptions } = appContainer
      .get<IViewerStoreInjector>(TYPES.Store.Viewer)
      .getState();

    if (zoom >= zoomConfig.maxZoom) return;

    setViewOptions(null);
    setZoom(zoom + zoomConfig.zoomStep / 5);
  },
};
